type SaleStatus = {
  isSaleStarted: boolean;
  isSaleEnded: boolean;
  isContactGallery: boolean;
};

export function getSaleLabel({ isSaleStarted, isSaleEnded, isContactGallery }: SaleStatus): string {
  if (isSaleStarted && !isContactGallery) {
    return 'Buy Now';
  }

  if (isSaleStarted && isContactGallery) {
    return 'Contact Gallery';
  }

  if (!isSaleStarted && isSaleEnded && isContactGallery) {
    return 'Contact Gallery';
  }

  if (isSaleEnded) {
    return 'Sale has ended';
  }

  return 'Not live yet';
}

export function isButtonDisabled({ isSaleStarted, isSaleEnded, isContactGallery }: SaleStatus): boolean {
  // Disable button for "Not live yet" (!isSaleStarted && !isSaleEnded) or "Sale has ended" (isSaleEnded && !isContactGallery)
  return (!isSaleStarted && !isSaleEnded) || (isSaleEnded && !isContactGallery);
}
